module.exports = __webpack_public_path__ + "img/agent-skills.aa437df6.webp";